export enum SectionType {
  LIST = 'LIST',
  LIST_ITEM = 'LIST_ITEM',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  BUTTON = 'BUTTON',
}
